
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 0h24v24H0z","data-name":"사각형 1172","fill":"none"}}),_c('path',{attrs:{"d":"M22.4 10.6h-9v-9h-2.8v9h-9v2.8h9v9h2.8v-9h9z","data-name":"패스 1186"}})])
          )
        }
      }
    